export interface ComplianceMetrics {
  complianceRate: number;
  updatedPolicies: string;
  certifiedEmployees: string;
  pendingAudits: number;
}

export interface PendingAction {
  id: string;
  title: string;
  dueDate: string;
  responsible: string;
  priority: 'Alta' | 'Media';
}

export interface CompanyPolicy {
  id: string;
  title: string;
  lastUpdate: string;
  status: 'completed' | 'pending';
}

export interface CertificationStatus {
  category: string;
  percentage: number;
}

export interface UpcomingTraining {
  id: string;
  title: string;
  date: string;
}

export interface QuickAction {
  id: string;
  icon: string;
  title: string;
}

export const complianceMetrics: ComplianceMetrics = {
  complianceRate: 98.2,
  updatedPolicies: '15/16',
  certifiedEmployees: '234/247',
  pendingAudits: 2,
};

export const pendingActions: PendingAction[] = [
  {
    id: '1',
    title: 'Actualizar política de privacidad',
    dueDate: '24/1/2024',
    responsible: 'Equipo Legal',
    priority: 'Alta',
  },
  {
    id: '2',
    title: 'Capacitación en manejo de datos',
    dueDate: '31/1/2024',
    responsible: 'Recursos Humanos',
    priority: 'Media',
  },
  {
    id: '3',
    title: 'Revisión de límites de adelanto',
    dueDate: '4/2/2024',
    responsible: 'Finanzas',
    priority: 'Media',
  },
];

export const companyPolicies: CompanyPolicy[] = [
  {
    id: '1',
    title: 'Política de Adelantos',
    lastUpdate: '9/1/2024',
    status: 'completed',
  },
  {
    id: '2',
    title: 'Código de Conducta',
    lastUpdate: '14/12/2023',
    status: 'completed',
  },
  {
    id: '3',
    title: 'Manejo de Datos Personales',
    lastUpdate: '19/11/2023',
    status: 'pending',
  },
  {
    id: '4',
    title: 'Políticas de Seguridad',
    lastUpdate: '4/1/2024',
    status: 'completed',
  },
];

export const certificationStatuses: CertificationStatus[] = [
  { category: 'Manejo de Datos', percentage: 94.5 },
  { category: 'Políticas Internas', percentage: 97.2 },
  { category: 'Seguridad Financiera', percentage: 87.4 },
];

export const upcomingTrainings: UpcomingTraining[] = [
  {
    id: '1',
    title: 'Actualización Compliance',
    date: '15 de Febrero',
  },
  {
    id: '2',
    title: 'Nuevas Regulaciones',
    date: '1 de Marzo',
  },
];

export const quickActions: QuickAction[] = [
  {
    id: '1',
    icon: 'description',
    title: 'Generar Reporte de Compliance',
  },
  {
    id: '2',
    icon: 'edit',
    title: 'Actualizar Políticas',
  },
  {
    id: '3',
    icon: 'schedule',
    title: 'Programar Auditoría',
  },
];
